import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import uuid from 'uuid/v4';
import Tooltip from '@material-ui/core/Tooltip';

export function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      data-test="TypographyComponent"
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box data-test="TypographyComponent" p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

const useStylesBootstrap = makeStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#30435D',
    border: '1px solid #ccc',
    margin: '0px',
    fontSize: 11,
    maxWidth: 'none',
  },
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip classes={classes} {...props} />;
}

const ScrollableTabs = ({
  tabs,
  runMMEReport,
  landingIndex,
}) => {
  const classes = useStyles();

  // const [value, setValue] = useState(0);
  const handleChange = event => {
    // setValue(newValue);
    // const activeTarget = tabs.find(item => toUpper(item.tab.title).replace(/ {2,}/g, ' ')
    //   .trim() === event.target.innerText).tab.keyword;
    const activeTarget = event.currentTarget.getAttribute('data-keyword');
    runMMEReport(activeTarget);
  };

  // useEffect(() => {
  //   setValue(tabs.findIndex(tabItem => tabItem.tab.keyword === landingTarget));
  // }, [landingTarget]);

  const tab = tabs.map((item, key) => {
    return (<BootstrapTooltip title={item.tab.title}>
      <Tab
        data-test="TabComponent"
        key={uuid()}
        label={item.tab.title}
        // title={item.tab.title}
        data-keyword={item.tab.keyword}
        {...a11yProps(key)}
      /></BootstrapTooltip>);
  });

  const tabPanel = tabs.map((item, key) => {
    return (<TabPanel data-test="TabPanelComponent" key={uuid()} value={landingIndex} index={key} >
      {item.content}
    </TabPanel>);
  });

  return (
    <div className={classes.root} data-test="ScrollableTabsComponent">
      <AppBar position="static" color="default">
        <Tabs
          data-test="TabsElem"
          value={landingIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {tab}
        </Tabs>
      </AppBar>
      {tabPanel}
    </div>
  );
};

ScrollableTabs.propTypes = {
  tabs: PropTypes.instanceOf(Array),
  runMMEReport: PropTypes.func,
  landingIndex: PropTypes.number,
};

export default ScrollableTabs;
